import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFont = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 1.75H2.75C2.19772 1.75 1.75 2.19772 1.75 2.75V4.75M8 1.75H13.25C13.8023 1.75 14.25 2.19772 14.25 2.75V4.75M8 1.75V18.25M8 18.25H5.75M8 18.25H10.25M15.125 10H12.5C12.2239 10 12 10.2239 12 10.5V11.5M15.125 10H17.75C18.0261 10 18.25 10.2239 18.25 10.5V11.5M15.125 10V18.25M15.125 18.25H14M15.125 18.25H16.25",
		stroke: "#3052AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgFont);
export { ForwardRef as ReactComponent };
